export const BIRDIE_CLIENT_ID = 'isgzqbcw'
